interface IUserPet {
    userPetName: string;
    userPetId?: string;
    userPetBreed: string;
    petBreedName?: string;
    userPetBreedId?: string;
    userPetBirthDate: Date | string;
    isOther: boolean;
    isSelected: boolean;
}

const initialUserPet: IUserPet = {
    userPetName: '',
    userPetId: null,
    userPetBreed: '',
    petBreedName: '',
    userPetBreedId: null,
    userPetBirthDate: null,
    isOther: false,
    isSelected: false,
};

export type { IUserPet };

export { initialUserPet };
